<template>
  <v-app>

  <router-view align="left" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

import {
  UserItem,
  Notificacion,
  Navbar,
  Footer,
  LeftSidebar,
  Comentarios,
} from "@/components/layout";

import MenuBarra from "./components/MenuBarra";
import MenuIzquierdo from "./components/MenuIzquierdo";

export default {
  components: {
    UserItem,
    LeftSidebar,
    Notificacion,
    Navbar,
    Footer,
    MenuBarra,
    MenuIzquierdo,
  },
  data() {
    return {
      left: false,
    };
  },
  computed: {
    ...mapState({
     
    }),
    ...mapState(["msize"]),
    estilos() {
      if (this.$vuetify.breakpoint.mdAndDown) return "padding-bottom:10%; ";
      else return "padding-bottom:10%; margin-left: 120px; margin-right:38px;";
    },
  },

  
  mounted() {
    // this.obtenerUsuarios()

    // console.log("state.oidc.user.Id_Empleado", this.$store.state.oidcStore);

    // this.id_empleado = state.oidc.user.Id_Empleado, this.nua = state.oidc.user.NUA
    console.log("vm", this.$vuetify.breakpoint);
  },
  methods: {
   
    closeSidebar() {
      this.left = !this.left;
    },
    ...mapActions(["obtenerUsuarios"]),
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Raleway:100,200,300,400,500,600,700,900");

#app {
      font-family: "Raleway" !important;
  /* FONDOS COLORES
    /* background: #d5d0ba; */
  background: #ffffff;
  /* background: #f9f9f9; */
  // background: #f0efed;
}

.v-toolbar__content {
  padding-left: 9px !important;
  padding-right: 9px !important;
}

.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating)
  .v-navigation-drawer__border {
  background-color: transparent !important;
}
</style>

